import axios from 'axios'

const API_ENDPOINT = '/auth'

const qstToken = (token, questionnaire) => {
  if (!token || token.length !== 40)
    return {then: () => false};
  return axios.get(`${API_ENDPOINT}/questionnaire/${questionnaire}/${token}`)
}

export default qstToken;